<template>
  <div>
    <prod-overview-stats v-if="product.ready" :product="product"></prod-overview-stats>
  </div>
</template>
<script>
  import db from '@/components/firebase/init'
  import firebase from 'firebase'

  const ProdOverviewStats = () => ({
    component: import('./../Components/ProdOverviewStats.vue')
  })

  export default {
    components: {
      ProdOverviewStats
    },
    props: ['accountData'],
    data () {
      return {
        user: {},
        product: {
          ready: false
        }
      }
    },
    methods: {
      async init () {
        var doc = await db.collection(`brands/${this.accountData.activeBrand.id}/products`).doc(this.$route.params.id).get()
        this.product.id = doc.id
        this.product.data = doc.data()
        this.product.validationData = []
        this.product.registrationData = []
        this.product.totalValidations = 0
        this.product.totalRegistrations = 0
        this.product.validationDataReady = false
        this.product.registrationDataReady = false
        this.product.ready = true
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        this.init()
      })
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Dashboard/ProductOverview.vue